import Store from '@/store';
import SLSTabelaprecoClient from '@/api/SistemaDKP/SLSTabelapreco.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSTabelaprecoService {
  constructor() {
    this.client = new SLSTabelaprecoClient();
    this.error = new ErrorMessage();
    this.store = Store;
    this.cache = new Map();
  }

  async getTabelaPrecoByClienteIdERP(clienteIdERP, queries) {
    this.store.commit('SLSTabelapreco/SET_LOADING', true);

    try {
      const data = await this.client.getTabelaPrecoByClienteIdERP(clienteIdERP, queries);
      this.store.commit('SLSTabelapreco/SET_TABELAPRECOS', data);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tabela de Preço');
    } finally {
      this.store.commit('SLSTabelapreco/SET_LOADING', false);
    }
  }
}
